export const getWorkspaceAuthorByline = ({
  isOwner,
  ownerNames,
  currentUserName,
}: {
  isOwner: boolean
  ownerNames?: string[] | null
  currentUserName?: string | null
}): string | null => {
  const names = ownerNames?.map((name) => name.trim()).filter(Boolean) ?? []
  if (isOwner || names.length === 0) return null

  const normalizedCurrentUserName = currentUserName?.trim().toLocaleLowerCase()
  if (
    normalizedCurrentUserName &&
    names.some((name) => name.toLocaleLowerCase() === normalizedCurrentUserName)
  ) {
    return null
  }

  return names.join(', ')
}
